import React, { useCallback } from 'react';

import { OnClick } from '@rbilabs/components-library';
import { useNavigate } from 'react-router-dom';

import { TextWithArrowButton } from 'components/text-with-arrow-button';
import { routes } from 'utils/routing';

import { ContentBlock, FullLineSeparator, TextButtonsWrapper } from '../../styled';

export const PhysicalCardContentSection = ({ onDismiss }: { onDismiss: OnClick }) => {
  const navigate = useNavigate();

  const handleGoToRoute = useCallback(
    (e, route: string) => {
      onDismiss(e);
      navigate(route, { replace: true });
    },
    [onDismiss, navigate]
  );

  return (
    <ContentBlock margin="0 0 5rem">
      <TextButtonsWrapper>
        <FullLineSeparator margin={`0`} />
        <TextWithArrowButton
          onClick={() => handleGoToRoute('', routes.timsRewards)}
          messageId="registerYourPhysicalCard"
        />
        <FullLineSeparator margin={`0`} />
      </TextButtonsWrapper>
    </ContentBlock>
  );
};

export default PhysicalCardContentSection;
